module.exports = __webpack_public_path__ + "img/temp-cover-pc.2651dc84.jpg";